<template>
    <div class="scroll-control alt-mode">
        <div class="slick-promoted-products-scroll-control" :class="{ centered: promotedProducts.length < 4 }">
            <div v-for="product in promotedProducts" :key="product.id" class="card product-card">
                <product-card
                    :product="product"
                    :user="user"
                    :isRep="isRep"
                    :locale="locale"
                    :products-basket-count="productsBasketCount"
                    :isPromoted="true"
                ></product-card>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "PromotedProducts",
    props: [
        'promotedProducts',
        'user',
        'locale',
        'isRep',
        'productsBasketCount',
    ],

    mounted() {

    }
}
</script>
